import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';
import { repositories, } from 'api';

export const fetchOrder = createAsyncAction(
    types.FETCH_ORDER_REQUEST,
    types.FETCH_ORDER_SUCCEEDED,
    types.FETCH_ORDER_FAILED,
)<never, repositories.order.OrderType, any>();
